import { render, staticRenderFns } from "./RecordWindow.vue?vue&type=template&id=6c0f9e20"
import script from "./RecordWindow.vue?vue&type=script&lang=js"
export * from "./RecordWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports